import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  insertarApiRespuesta,
  listado_datosEstudiante_logeadoSinLoading,
  listado_encuesta_listasHabilitadas,
  listado_encuesta_listasPreguntas,
} from "../../services/procesoMatricula/procesoMatricula";
import useMatricula from "../../hooks/useMatricula";
import useProcesoMatricula from "../../hooks/useProcesoMatricula";
import { encuesta_caracters } from "../../config/constantes";

let data = [
  {
    indicaciones:
      "Nos gustaría conocer el grado de satisfacción con respecto al uso del nuevo portal de matrícula. A continuación, encontrarás las siguientes preguntas, por favor marca la respuesta que consideres apropiada según tu nivel de satisfacción: (1) totalmente en desacuerdo, (2) desacuerdo, (3) Indeciso, (4) de acuerdo y (5) totalmente de acuerdo.",
    grupo_pregunta: "A",
    gtipo_grupo_pregunta: 1,
    norden_grupo_pregunta: 1,
    cencuesta: 1,
    dencuesta: "ENCUESTA DE SATISFACCIÓN",
    indicaciones_grupo_pregunta: "Indicaciones del grupo A",
    cantidad_opciones: 5,
    preguntas: [
      {
        cpregunta: 1,
        pregunta: "Me fue fácil acceder al nuevo portal de matrícula",
        norden_pregunta: 1,
        gtipo_pregunta: 1,
        dtipo_pregunta: "OPCIÓN MÚLTIPLE",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 1,
            opcion: "1",
            valor_opcion: "1",
            grequerido_pregunta: 1,
            norden_opcion: 1,
          },
          {
            copcion: 2,
            opcion: "2",
            valor_opcion: "2",
            grequerido_pregunta: 1,
            norden_opcion: 2,
          },
          {
            copcion: 3,
            opcion: "3",
            valor_opcion: "3",
            grequerido_pregunta: 1,
            norden_opcion: 3,
          },
          {
            copcion: 4,
            opcion: "4",
            valor_opcion: "4",
            grequerido_pregunta: 1,
            norden_opcion: 4,
          },
          {
            copcion: 5,
            opcion: "5",
            valor_opcion: "5",
            grequerido_pregunta: 1,
            norden_opcion: 5,
          },
        ],
      },
      {
        cpregunta: 2,
        pregunta: "Me agradó la apariencia del nuevo portal",
        norden_pregunta: 2,
        gtipo_pregunta: 1,
        dtipo_pregunta: "OPCIÓN MÚLTIPLE",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 6,
            opcion: "1",
            valor_opcion: "1",
            grequerido_pregunta: 1,
            norden_opcion: 1,
          },
          {
            copcion: 7,
            opcion: "2",
            valor_opcion: "2",
            grequerido_pregunta: 1,
            norden_opcion: 2,
          },
          {
            copcion: 8,
            opcion: "3",
            valor_opcion: "3",
            grequerido_pregunta: 1,
            norden_opcion: 3,
          },
          {
            copcion: 9,
            opcion: "4",
            valor_opcion: "4",
            grequerido_pregunta: 1,
            norden_opcion: 4,
          },
          {
            copcion: 10,
            opcion: "5",
            valor_opcion: "5",
            grequerido_pregunta: 1,
            norden_opcion: 5,
          },
        ],
      },
      {
        cpregunta: 3,
        pregunta: "Encontré todos los cursos que esperaba",
        norden_pregunta: 3,
        gtipo_pregunta: 1,
        dtipo_pregunta: "OPCIÓN MÚLTIPLE",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 11,
            opcion: "1",
            valor_opcion: "1",
            grequerido_pregunta: 1,
            norden_opcion: 1,
          },
          {
            copcion: 12,
            opcion: "2",
            valor_opcion: "2",
            grequerido_pregunta: 1,
            norden_opcion: 2,
          },
          {
            copcion: 13,
            opcion: "3",
            valor_opcion: "3",
            grequerido_pregunta: 1,
            norden_opcion: 3,
          },
          {
            copcion: 14,
            opcion: "4",
            valor_opcion: "4",
            grequerido_pregunta: 1,
            norden_opcion: 4,
          },
          {
            copcion: 15,
            opcion: "5",
            valor_opcion: "5",
            grequerido_pregunta: 1,
            norden_opcion: 5,
          },
        ],
      },
      {
        cpregunta: 4,
        pregunta: "Encontré la información adecuada",
        norden_pregunta: 4,
        gtipo_pregunta: 1,
        dtipo_pregunta: "OPCIÓN MÚLTIPLE",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 16,
            opcion: "1",
            valor_opcion: "1",
            grequerido_pregunta: 1,
            norden_opcion: 1,
          },
          {
            copcion: 17,
            opcion: "2",
            valor_opcion: "2",
            grequerido_pregunta: 1,
            norden_opcion: 2,
          },
          {
            copcion: 18,
            opcion: "3",
            valor_opcion: "3",
            grequerido_pregunta: 1,
            norden_opcion: 3,
          },
          {
            copcion: 19,
            opcion: "4",
            valor_opcion: "4",
            grequerido_pregunta: 1,
            norden_opcion: 4,
          },
          {
            copcion: 20,
            opcion: "5",
            valor_opcion: "5",
            grequerido_pregunta: 1,
            norden_opcion: 5,
          },
        ],
      },
      {
        cpregunta: 5,
        pregunta: "La navegación me pareció sencilla",
        norden_pregunta: 5,
        gtipo_pregunta: 1,
        dtipo_pregunta: "OPCIÓN MÚLTIPLE",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 21,
            opcion: "1",
            valor_opcion: "1",
            grequerido_pregunta: 1,
            norden_opcion: 1,
          },
          {
            copcion: 22,
            opcion: "2",
            valor_opcion: "2",
            grequerido_pregunta: 1,
            norden_opcion: 2,
          },
          {
            copcion: 23,
            opcion: "3",
            valor_opcion: "3",
            grequerido_pregunta: 1,
            norden_opcion: 3,
          },
          {
            copcion: 24,
            opcion: "4",
            valor_opcion: "4",
            grequerido_pregunta: 1,
            norden_opcion: 4,
          },
          {
            copcion: 25,
            opcion: "5",
            valor_opcion: "5",
            grequerido_pregunta: 1,
            norden_opcion: 5,
          },
        ],
      },
      {
        cpregunta: 6,
        pregunta: "No tuve problemas al realizar el pago",
        norden_pregunta: 6,
        gtipo_pregunta: 1,
        dtipo_pregunta: "OPCIÓN MÚLTIPLE",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 26,
            opcion: "1",
            valor_opcion: "1",
            grequerido_pregunta: 1,
            norden_opcion: 1,
          },
          {
            copcion: 27,
            opcion: "2",
            valor_opcion: "2",
            grequerido_pregunta: 1,
            norden_opcion: 2,
          },
          {
            copcion: 28,
            opcion: "3",
            valor_opcion: "3",
            grequerido_pregunta: 1,
            norden_opcion: 3,
          },
          {
            copcion: 29,
            opcion: "4",
            valor_opcion: "4",
            grequerido_pregunta: 1,
            norden_opcion: 4,
          },
          {
            copcion: 30,
            opcion: "5",
            valor_opcion: "5",
            grequerido_pregunta: 1,
            norden_opcion: 5,
          },
        ],
      },
    ],
  },
  {
    indicaciones:
      "Nos gustaría conocer el grado de satisfacción con respecto al uso del nuevo portal de matrícula. A continuación, encontrarás las siguientes preguntas, por favor marca la respuesta que consideres apropiada según tu nivel de satisfacción: (1) totalmente en desacuerdo, (2) desacuerdo, (3) Indeciso, (4) de acuerdo y (5) totalmente de acuerdo.",
    grupo_pregunta: "B",
    gtipo_grupo_pregunta: 2,
    norden_grupo_pregunta: 2,
    cencuesta: 1,
    dencuesta: "ENCUESTA DE SATISFACCIÓN",
    indicaciones_grupo_pregunta: "Indicaciones del grupo B",
    cantidad_opciones: 3,
    preguntas: [
      {
        cpregunta: 7,
        pregunta:
          "En comparación con el portal de matricula anterior, ¿Cuál es tu opinión respecto a tu experiencia con el nuevo portal de matricula?",
        norden_pregunta: 7,
        gtipo_pregunta: 1,
        dtipo_pregunta: "OPCIÓN MÚLTIPLE",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 31,
            opcion: "Mejor",
            valor_opcion: "1",
            grequerido_pregunta: 1,
            norden_opcion: 1,
          },
          {
            copcion: 32,
            opcion: "Peor",
            valor_opcion: "2",
            grequerido_pregunta: 1,
            norden_opcion: 2,
          },
          {
            copcion: 33,
            opcion: "Igual",
            valor_opcion: "3",
            grequerido_pregunta: 1,
            norden_opcion: 3,
          },
        ],
      },
    ],
  },
  {
    indicaciones:
      "Nos gustaría conocer el grado de satisfacción con respecto al uso del nuevo portal de matrícula. A continuación, encontrarás las siguientes preguntas, por favor marca la respuesta que consideres apropiada según tu nivel de satisfacción: (1) totalmente en desacuerdo, (2) desacuerdo, (3) Indeciso, (4) de acuerdo y (5) totalmente de acuerdo.",
    grupo_pregunta: "C",
    gtipo_grupo_pregunta: 2,
    norden_grupo_pregunta: 3,
    cencuesta: 1,
    dencuesta: "ENCUESTA DE SATISFACCIÓN",
    indicaciones_grupo_pregunta: "Indicaciones del grupo C",
    cantidad_opciones: 2,
    preguntas: [
      {
        cpregunta: 8,
        pregunta:
          "¿Encontraste algún inconveniente usando el nuevo portal de matricula?",
        norden_pregunta: 8,
        gtipo_pregunta: 1,
        dtipo_pregunta: "OPCIÓN MÚLTIPLE",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 34,
            opcion: "Sí",
            valor_opcion: "1",
            grequerido_pregunta: 1,
            norden_opcion: 1,
          },
          {
            copcion: 35,
            opcion: "No",
            valor_opcion: "2",
            grequerido_pregunta: 1,
            norden_opcion: 2,
          },
        ],
      },
    ],
  },
  {
    indicaciones:
      "Nos gustaría conocer el grado de satisfacción con respecto al uso del nuevo portal de matrícula. A continuación, encontrarás las siguientes preguntas, por favor marca la respuesta que consideres apropiada según tu nivel de satisfacción: (1) totalmente en desacuerdo, (2) desacuerdo, (3) Indeciso, (4) de acuerdo y (5) totalmente de acuerdo.",
    grupo_pregunta: "D",
    gtipo_grupo_pregunta: 2,
    norden_grupo_pregunta: 4,
    cencuesta: 1,
    dencuesta: "ENCUESTA DE SATISFACCIÓN",
    indicaciones_grupo_pregunta: "Indicaciones del grupo D",
    cantidad_opciones: 0,
    preguntas: [
      {
        cpregunta: 9,
        pregunta:
          "Tu opinión es importante para nosotros, por favor comparte alguna observación o sugerencia con nosotros.",
        norden_pregunta: 9,
        gtipo_pregunta: 4,
        dtipo_pregunta: "TEXTO LARGO",
        enumeracion_pregunta: null,
        grequerido_pregunta: 1,
        opciones: [
          {
            copcion: 0,
            opcion: null,
            valor_opcion: null,
            grequerido_pregunta: 1,
            norden_opcion: 0,
          },
        ],
      },
    ],
  },
];

const ModalEncuestaSatisfaccion = ({ show, handleClose, encuestas }) => {
  const {
    obtenerDatosEstudiante,
    setObtenerDatosEstudiante,
    setObtenerDatosEstudianteSinFiltro,
  } = useMatricula();

  const { setLoading, setErrorCursoServices } = useProcesoMatricula();

  const [listaPreguntasEncuesta, setListaPreguntasEncuesta] = useState([]);

  const [dataForms, setDataForms] = useState({});

  const [
    listaPreguntasEncuestaFormateada,
    setListaPreguntasEncuestaFormateada,
  ] = useState([]);

  const { cencuesta, dencuesta, indicaciones } = encuestas || {};

  const buildDataForm = (data) => {
    let setDataForm = {};
    data.forEach((value, index) => {
      value?.preguntas.forEach((element) => {
        let preguntasForm = {
          cpregunta: element.cpregunta,
          gtipo_pregunta: element.gtipo_pregunta,
          grequerido_pregunta: element.grequerido_pregunta,
          opciones: element.opciones.map((opcion) => {
            return ({
              id: opcion.copcion,
              copcion: null,
              valor_opcion: null,
              maxLength: "00"
            })
          }),

          mensajeError: false,

        };

        if (!setDataForm[element?.cpregunta]) {
          setDataForm[element?.cpregunta] = [];
        }
        setDataForm[element?.cpregunta].push(preguntasForm);

      });
    });

    setDataForms(setDataForm);
  };

  const buildDataForm2 = (data) => {
    let setDataForm = {};
    data.forEach((value, index) => {
      value?.preguntas.forEach((element) => {
        let preguntasForm = {
          cpregunta: element.cpregunta,
          gtipo_pregunta: element.gtipo_pregunta,
          grequerido_pregunta: element.grequerido_pregunta,
          copcion: null,
          valor_opcion: null,
          mensajeError: false,
          maxLength: "00",
        };

        if (!setDataForm[element?.cpregunta]) {
          setDataForm[element?.cpregunta] = [];
        }
        setDataForm[element?.cpregunta].push(preguntasForm);
      });
    });

    setDataForms(setDataForm);
  };
  const resultFormattedFormulario = (data) => {

    const formattedData = [];
    data.forEach((preguntas) => {
      const existingGroup = formattedData.find(
        (item) => item.grupo_pregunta === preguntas.grupo_pregunta
      );

      if (existingGroup) {
        const existingQuestion = existingGroup.preguntas.find(
          (item) => item.cpregunta === preguntas.cpregunta
        );

        if (existingQuestion) {
          existingQuestion.opciones.push({
            copcion: preguntas.copcion,
            opcion: preguntas.opcion,
            valor_opcion: preguntas.valor_opcion,
            grequerido_pregunta: preguntas.grequerido_pregunta,
            norden_opcion: preguntas.norden_opcion,
          });
        } else {
          existingGroup.preguntas.push({
            cpregunta: preguntas.cpregunta,
            pregunta: preguntas.pregunta,
            norden_pregunta: preguntas.norden_pregunta,
            gtipo_pregunta: preguntas.gtipo_pregunta,
            dtipo_pregunta: preguntas.dtipo_pregunta,
            enumeracion_pregunta: preguntas.enumeracion_pregunta,
            grequerido_pregunta: preguntas.grequerido_pregunta,
            opciones: [
              {
                copcion: preguntas.copcion,
                opcion: preguntas.opcion,
                valor_opcion: preguntas.valor_opcion,
                grequerido_pregunta: preguntas.grequerido_pregunta,
                norden_opcion: preguntas.norden_opcion,
              },
            ],
          });
        }
      } else {
        formattedData.push({
          indicaciones: preguntas.indicaciones,
          grupo_pregunta: preguntas.grupo_pregunta,
          gtipo_grupo_pregunta: preguntas.gtipo_grupo_pregunta,
          norden_grupo_pregunta: preguntas.norden_grupo_pregunta,
          cencuesta: preguntas.cencuesta,
          dencuesta: preguntas.dencuesta,
          indicaciones_grupo_pregunta: preguntas.indicaciones_grupo_pregunta,
          titulo_grupo_pregunta: preguntas.titulo_grupo_pregunta,
          cantidad_opciones: preguntas.cantidad_opciones,
          preguntas: [
            {
              cpregunta: preguntas.cpregunta,
              pregunta: preguntas.pregunta,
              norden_pregunta: preguntas.norden_pregunta,
              gtipo_pregunta: preguntas.gtipo_pregunta,
              dtipo_pregunta: preguntas.dtipo_pregunta,
              enumeracion_pregunta: preguntas.enumeracion_pregunta,
              grequerido_pregunta: preguntas.grequerido_pregunta,
              opciones: [
                {
                  copcion: preguntas.copcion,
                  opcion: preguntas.opcion,
                  valor_opcion: preguntas.valor_opcion,
                  grequerido_pregunta: preguntas.grequerido_pregunta,
                  norden_opcion: preguntas.norden_opcion,
                },
              ],
            },
          ],
        });
      }
    });

    setListaPreguntasEncuestaFormateada(formattedData);
    buildDataForm(formattedData);
  };
  useEffect(() => {

    const { gencuesta } = obtenerDatosEstudiante || {};
    const listEncuestas = async () => {

      try {
        setLoading(true);

        let lisPreguntas = await listado_encuesta_listasPreguntas(cencuesta);
        setListaPreguntasEncuesta(lisPreguntas);

        resultFormattedFormulario(lisPreguntas);
      } catch (error) {
      } finally {
        setLoading(false);
      }


    };
    if (gencuesta !== 1) {


      listEncuestas();
    }

  }, [obtenerDatosEstudiante]);
  useEffect(() => {
    setLoading(true)
  }, [])

  const buscarValorPuntaje = (encuesta) => {

    let busquedaCantidadOpciones = encuesta.preguntas.filter((p) => {
      return p.opciones.length === encuesta.cantidad_opciones;
    });

    return busquedaCantidadOpciones[0].opciones;
  };

  const armarCadena2 = () => {
    let cadena = "";
    Object.keys(dataForms).forEach((key) => {
      const preguntasFormArray = dataForms[key];
      preguntasFormArray.forEach((preguntasForm) => {
        if (
          preguntasForm.valor_opcion !== null &&
          preguntasForm.copcion !== null
        ) {
          cadena += `${preguntasForm.cpregunta}~${preguntasForm.gtipo_pregunta}~${preguntasForm.copcion}~${preguntasForm.valor_opcion}|`;
        }
      });
    });

    cadena = cadena.slice(0, -1);
    return cadena;
  };

  const armarCadena = () => {
    let cadena = "";
    Object.keys(dataForms).forEach((key) => {
      const preguntasFormArray = dataForms[key];
      preguntasFormArray.forEach((preguntasForm) => {
        preguntasForm.opciones.forEach(data => {
          if (data.valor_opcion !== null && data.copcion !== null) {
            cadena += `${preguntasForm.cpregunta}~${preguntasForm.gtipo_pregunta}~${data.copcion}~${data.valor_opcion}|`;
          }

        });
      });
    });

    cadena = cadena.slice(0, -1);


    return cadena;
  };

  const handleEnviar = async (e) => {
    e.preventDefault();

    const updatedDataForm = { ...dataForms };
    let todasOpcionesNull = true;
    Object.values(updatedDataForm).forEach((preguntasArray) => {
      preguntasArray.forEach((preguntasForm) => {
        const opcionesNull = preguntasForm.opciones.every(
          (eOpcion) => eOpcion.copcion === null && eOpcion.valor_opcion === null
        );


        if (
          opcionesNull &&
          preguntasForm.grequerido_pregunta === 1
        ) {
          preguntasForm.mensajeError = true;
          todasOpcionesNull = true;
        } else {
          preguntasForm.mensajeError = false;
          todasOpcionesNull = false;
        }
      });
    });

    setDataForms(updatedDataForm);

    if (todasOpcionesNull) {

    } else {
      try {
        let parametros = {
          cencuesta: cencuesta,
          cadena_respuestas: armarCadena(),
        };


        setLoading(true);
        await insertarApiRespuesta(obtenerDatosEstudiante, parametros);
        handleClose();
        await listado_datosEstudiante_logeadoSinLoading(
          setObtenerDatosEstudianteSinFiltro,
          setObtenerDatosEstudiante,
          obtenerDatosEstudiante
        );
      } catch (error) {
        setErrorCursoServices(error.message);
        document.querySelector("#errorAsignatura").click();
      } finally {
        setLoading(false);
      }

    }


  };

  const validarMensajeError = (key) => {

    const { cpregunta, opciones } = key

    return dataForms[cpregunta][0].mensajeError;
  };

  const visualizarLongitudText = (key) => {

    const { cpregunta, opciones } = key
    let opcions = opciones[0].copcion;


    let [arrayPregunta] = dataForms[cpregunta][0].opciones.filter(e => e.id === opcions);



    return arrayPregunta.maxLength;
  };

  const obtenerValor = (key) => {


    return dataForms[key][0].valor_opcion === null
      ? ""
      : dataForms[key][0].valor_opcion;
  };
  const changeDataForm = (cpregunta, objectOption, opcion) => {

    const { copcion, valor_opcion } = objectOption;
    const updatedDataForm = { ...dataForms };
    Object.values(updatedDataForm).forEach((preguntasArray) => {
      preguntasArray.forEach((preguntasForm) => {
        if (preguntasForm.cpregunta === cpregunta) {
          preguntasForm.opciones.forEach((eOpcion) => {
            if (eOpcion.id === opcion?.copcion) {

              if (eOpcion.copcion === opcion?.copcion) {
                if (preguntasForm.gtipo_pregunta === 2) {
                  eOpcion.copcion = null;
                  eOpcion.valor_opcion = null;
                  eOpcion.maxLength = "00";
                  return;
                }
              }

              eOpcion.copcion =
                typeof valor_opcion === "string" && valor_opcion.trimStart() !== ""
                  ? copcion
                  : null;
              eOpcion.valor_opcion =
                typeof valor_opcion === "string" && valor_opcion.trimStart() !== ""
                  ? valor_opcion.trimStart()
                  : null;
              if (preguntasForm.gtipo_pregunta !== 2) {
                eOpcion.maxLength = valor_opcion === null ? "00" : valor_opcion?.length?.toString().padStart(2, "0");
              }

            } else {

              if (preguntasForm.gtipo_pregunta != 2) {
                eOpcion.copcion = null;
                eOpcion.valor_opcion = null;
                eOpcion.maxLength = "00";
              }
            }

          });

          preguntasForm.mensajeError = false;
        }
      });
    });

    setDataForms(updatedDataForm);
  };

  const handleKeyPress = (e) => {
    const allowedChars = encuesta_caracters.split(",");
    const key = String.fromCharCode(!e.charCode ? e.which : e.charCode);
    if (allowedChars.includes(key) && key !== " ") {
      e.preventDefault();
      return false;
    }
  };
  return (
    <Modal show={show} centered size="lg">
      <Modal.Header>
        <Modal.Title>
          <h5 className="modal-title"> {dencuesta}</h5>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row mb-4">
          <div className="col-12">
            <p className="mb-0">{encuestas.indicaciones}</p>
          </div>
        </div>
        {listaPreguntasEncuestaFormateada.map((encuesta, index) => {
          return (
            <React.Fragment key={index}>


              <div className="card border rounded-3 mb-3">
                {encuesta.titulo_grupo_pregunta === "" ||
                  encuesta.titulo_grupo_pregunta === null ? (
                  <></>
                ) : (
                  <div className="card-header">
                    <p className="fw-medium mb-0">
                      {encuesta.titulo_grupo_pregunta}
                    </p>
                  </div>
                )}

                <div className="card-body">
                  <div className="row">
                    {encuesta.indicaciones_grupo_pregunta === "" ||
                      encuesta.indicaciones_grupo_pregunta === null ? (
                      <></>
                    ) : (
                      <p className="mb-3">{encuesta.indicaciones_grupo_pregunta}</p>
                    )}


                    {encuesta.gtipo_grupo_pregunta === 1 ? (
                      <div className="col-12 ">
                        <div className="form-group d-flex flex-wrap px-2 py-3">
                          <label htmlFor="q1" className="w-50" />
                          <div className="d-flex w-50 justify-content-between">


                            {buscarValorPuntaje(encuesta).map(
                              (valor, indexs) => {
                                return (
                                  <div
                                    className="form-check text-center px-1 "
                                    key={indexs}
                                  >
                                    <label
                                      className="form-check-label"
                                      htmlFor={` q${index}_${valor.valor_opcion}`}
                                    >
                                      {valor.valor_opcion}
                                    </label>
                                  </div>
                                );
                              }
                            )}
                          </div>
                        </div>
                        {encuesta.preguntas.map((preguntas, index2) => {
                          // Son listados que si coincide con la cantidad de opciones para darle un formato diferente y poder separarlo

                          return (
                            <React.Fragment key={index2}>
                              {preguntas.opciones.length ===
                                encuesta.cantidad_opciones && (
                                  <>
                                    <div className="form-group d-flex flex-wrap px-2 py-3 bg-light rounded-3 my-2">
                                      <label
                                        htmlFor={`q${index}`}
                                        className="w-50"
                                      >
                                        {preguntas.pregunta}
                                        {preguntas.grequerido_pregunta === 1 ? (
                                          <span className="text-danger">*</span>
                                        ) : (
                                          ""
                                        )}
                                      </label>
                                      <div className="d-flex w-50 justify-content-between">
                                        {preguntas.opciones.map(
                                          (opcion, index3) => {
                                            return (
                                              <div
                                                className="form-check"
                                                key={index3}
                                              >
                                                <input
                                                  className="form-check-input"
                                                  type={`${preguntas.gtipo_pregunta === 1
                                                      ? "radio"
                                                      : "checked"
                                                    }`}
                                                  name={`q${preguntas.cpregunta + index2
                                                    }`}
                                                  id={`q${index}_${opcion.valor_opcion}`}
                                                  defaultValue={
                                                    opcion.valor_opcion
                                                  }
                                                  onChange={(e) => {
                                                    changeDataForm(
                                                      preguntas.cpregunta,
                                                      opcion,
                                                      opcion
                                                    );
                                                  }}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor={`q${index}_${opcion.valor_opcion}`}
                                                />
                                              </div>
                                            );
                                          }
                                        )}
                                      </div>
                                    </div>
                                    {validarMensajeError(preguntas) ? (
                                      <span className="text-danger fs-12">
                                        *Por favor marcar una opción
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                )}
                            </React.Fragment>
                          );
                        })}

                        {encuesta.preguntas.map((preguntas, index2) => {
                          // Son listados que NO CONINCIDEN con la cantidad de opciones para darle un formato diferente y poder separarlo Y DIFERENCIARLO DONDE EL CLIENTE PUEDA CORREGIR ESA INCONCISTENCIA POR TEMA DE DATA

                          return (
                            <React.Fragment key={index2}>
                              {preguntas.opciones.length !==
                                encuesta.cantidad_opciones && (
                                  <>
                                    <div className="col-12 mb-3 mt-3">
                                      <p className="mb-3">
                                        {preguntas.pregunta}
                                        {preguntas.grequerido_pregunta === 1 ? (
                                          <span className="text-danger">*</span>
                                        ) : (
                                          ""
                                        )}
                                      </p>
                                      {preguntas.opciones.map(
                                        (opcion, index3) => {
                                          return (
                                            <React.Fragment key={index3}>
                                              {preguntas.gtipo_pregunta !== 4 && (
                                                <div
                                                  className={`mb-2 ${preguntas.gtipo_pregunta === 3
                                                      ? ""
                                                      : "form-check"
                                                    }`}
                                                >
                                                  {preguntas.gtipo_pregunta ===
                                                    1 ? (
                                                    <>
                                                      <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name={`options${index + index2
                                                          }`}
                                                        id={`options${index + index2
                                                          }`}
                                                        defaultValue={
                                                          opcion.valor_opcion
                                                        }
                                                        onChange={(e) => {
                                                          changeDataForm(
                                                            preguntas.cpregunta,
                                                            opcion,
                                                            opcion
                                                          );
                                                        }}
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor={`options${index + index2
                                                          }`}
                                                      >
                                                        {opcion.opcion}
                                                      </label>
                                                    </>
                                                  ) : preguntas.gtipo_pregunta ===
                                                    2 ? (
                                                    <>
                                                      <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        name={`options${index + index2
                                                          }}`}
                                                        id={`options${index + index2
                                                          }`}
                                                        defaultValue={
                                                          opcion.valor_opcion
                                                        }
                                                        onChange={(e) => {
                                                          changeDataForm(
                                                            preguntas.cpregunta,
                                                            opcion,
                                                            opcion
                                                          );
                                                        }}
                                                      />
                                                      <label
                                                        className="form-check-label"
                                                        htmlFor={`options${index + index2
                                                          }`}
                                                      >
                                                        {opcion.opcion}
                                                      </label>
                                                    </>
                                                  ) : preguntas.gtipo_pregunta ===
                                                    3 ? (
                                                    <>
                                                      <input
                                                        className="form-control"
                                                        type="text"
                                                        name={`options${index + index2
                                                          }}`}
                                                        id={`options${index + index2
                                                          }`}
                                                        onKeyPress={(e) =>
                                                          handleKeyPress(e)
                                                        }
                                                        onPaste={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        value={obtenerValor(
                                                          preguntas.cpregunta
                                                        )}
                                                        onChange={(e) => {
                                                          if (
                                                            e.target.value
                                                              .length <= 2000
                                                          ) {
                                                            changeDataForm(
                                                              preguntas.cpregunta,
                                                              {
                                                                copcion:
                                                                  e.target
                                                                    .value === ""
                                                                    ? null
                                                                    : opcion.copcion,
                                                                valor_opcion:
                                                                  e.target
                                                                    .value === ""
                                                                    ? null
                                                                    : e.target
                                                                      .value,
                                                              },
                                                              opcion
                                                            );
                                                          }
                                                        }}
                                                        maxLength={2000}
                                                      />

                                                      <p
                                                        className="mt-2 ms-2"
                                                        style={{
                                                          textAlign: "right",
                                                          fontSize: "14px",
                                                        }}
                                                      >
                                                        {visualizarLongitudText(
                                                          preguntas
                                                        )}{" "}
                                                        / 2000
                                                      </p>
                                                    </>
                                                  ) : null}
                                                </div>
                                              )}

                                              {preguntas.gtipo_pregunta === 4 && (
                                                <>
                                                  <textarea
                                                    className="form-control"
                                                    name={`options${index + index2
                                                      }}`}
                                                    onKeyPress={(e) =>
                                                      handleKeyPress(e)
                                                    }
                                                    onPaste={(e) => {
                                                      e.preventDefault();
                                                    }}
                                                    value={obtenerValor(
                                                      preguntas.cpregunta
                                                    )}
                                                    onChange={(e) => {
                                                      if (
                                                        e.target.value.length <=
                                                        2000
                                                      ) {
                                                        changeDataForm(
                                                          preguntas.cpregunta,
                                                          {
                                                            copcion:
                                                              e.target.value ===
                                                                ""
                                                                ? null
                                                                : opcion.copcion,
                                                            valor_opcion:
                                                              e.target.value ===
                                                                ""
                                                                ? null
                                                                : e.target.value,
                                                          },
                                                          opcion
                                                        );
                                                      }
                                                    }}
                                                    maxLength={2000}
                                                    rows="3"
                                                    key={index3}
                                                  />

                                                  <p
                                                    className="mt-2 ms-2"
                                                    style={{
                                                      textAlign: "right",
                                                      fontSize: "14px",
                                                    }}
                                                  >
                                                    {visualizarLongitudText(
                                                      preguntas
                                                    )}{" "}
                                                    / 2000
                                                  </p>
                                                </>
                                              )}
                                            </React.Fragment>
                                          );
                                        }
                                      )}
                                    </div>

                                    {validarMensajeError(preguntas) ? (
                                      <span className="text-danger fs-12">
                                        *Por favor marcar una opción
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                )}
                            </React.Fragment>
                          );
                        })}
                      </div>
                    ) : (
                      encuesta.preguntas.map((preguntas, index2) => {
                        return (
                          <div className="col-12" key={index2}>
                            <p className="mb-3">
                              {preguntas.pregunta}
                              {preguntas.grequerido_pregunta === 1 ? (
                                <span className="text-danger">*</span>
                              ) : (
                                ""
                              )}
                            </p>
                            {preguntas.opciones.map((opcion, index3) => {
                              return (
                                <React.Fragment key={index3}>
                                  {preguntas.gtipo_pregunta !== 4 && (
                                    <div
                                      className={`mb-2 ${preguntas.gtipo_pregunta === 3
                                          ? ""
                                          : "form-check"
                                        }`}
                                    >
                                      {preguntas.gtipo_pregunta === 1 ? (
                                        <>
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name={`options${index + index2}`}
                                            id={`options${index + index2}`}
                                            defaultValue={opcion.valor_opcion}
                                            onChange={(e) => {
                                              changeDataForm(
                                                preguntas.cpregunta,
                                                opcion,
                                                opcion
                                              );
                                            }}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor={`options${index + index2}`}
                                          >
                                            {opcion.opcion}
                                          </label>
                                        </>
                                      ) : preguntas.gtipo_pregunta === 2 ? (
                                        <>
                                          <input
                                            className="form-check-input"
                                            type="checkbox"
                                            name={`options${index + index2}}`}
                                            id={`options${index + index2}`}
                                            defaultValue={opcion.valor_opcion}
                                            onChange={(e) => {
                                              changeDataForm(
                                                preguntas.cpregunta,
                                                opcion,
                                                opcion
                                              );
                                            }}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor={`options${index + index2}`}
                                          >
                                            {opcion.opcion}
                                          </label>
                                        </>
                                      ) : preguntas.gtipo_pregunta === 3 ? (
                                        <>
                                          <input
                                            className="form-control"
                                            type="text"
                                            name={`options${index + index2}}`}
                                            id={`options${index + index2}`}
                                            onKeyPress={(e) =>
                                              handleKeyPress(e)
                                            }
                                            onPaste={(e) => {
                                              e.preventDefault();
                                            }}
                                            value={obtenerValor(
                                              preguntas.cpregunta
                                            )}
                                            onChange={(e) => {
                                              if (
                                                e.target.value.length <= 2000
                                              ) {
                                                changeDataForm(
                                                  preguntas.cpregunta,
                                                  {
                                                    copcion:
                                                      e.target.value === ""
                                                        ? null
                                                        : opcion.copcion,
                                                    valor_opcion:
                                                      e.target.value === ""
                                                        ? null
                                                        : e.target.value,
                                                  },
                                                  opcion
                                                );
                                              }
                                            }}
                                            maxLength={2000}
                                          />
                                          <p
                                            className="mt-2 ms-2"
                                            style={{
                                              textAlign: "right",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {visualizarLongitudText(
                                              preguntas
                                            )}{" "}
                                            / 2000
                                          </p>
                                        </>
                                      ) : null}

                                    </div>
                                  )}

                                  {preguntas.gtipo_pregunta === 4 && (
                                    <>
                                      <textarea
                                        className="form-control"
                                        name={`options${index + index2}}`}
                                        value={obtenerValor(
                                          preguntas.cpregunta
                                        )}
                                        onKeyPress={(e) => handleKeyPress(e)}
                                        onPaste={(e) => {
                                          e.preventDefault();
                                        }}
                                        onChange={(e) => {
                                          if (e.target.value.length <= 2000) {
                                            changeDataForm(
                                              preguntas.cpregunta,
                                              {
                                                copcion:
                                                  e.target.value === ""
                                                    ? null
                                                    : opcion.copcion,
                                                valor_opcion:
                                                  e.target.value === ""
                                                    ? null
                                                    : e.target.value,
                                              },
                                              opcion
                                            );
                                          }
                                        }}
                                        maxLength={2000}
                                        rows="3"
                                        key={index3}
                                      />
                                      <p
                                        className="mt-2 ms-2"
                                        style={{
                                          textAlign: "right",
                                          fontSize: "14px",
                                        }}
                                      >
                                        {visualizarLongitudText(
                                          preguntas
                                        )}{" "}
                                        / 2000
                                      </p>
                                    </>
                                  )}
                                </React.Fragment>
                              );
                            })}

                            {validarMensajeError(preguntas) ? (
                              <span className="text-danger fs-12">
                                *Por favor marcar una opción
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn btn-primary"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={handleEnviar}
        >
          Enviar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEncuestaSatisfaccion;
